import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { parseQueryString } from 'util/queryString'

const useQueryString = <T>() => {
  const location = useLocation()
  const [query, setQuery] = useState<T>(parseQueryString<T>())

  useEffect(() => {
    const updated = parseQueryString<T>()
    if (JSON.stringify(query) !== JSON.stringify(updated)) {
      setQuery(updated)
    }
  }, [location.search, query])

  return query as unknown as T
}

export default useQueryString
